module.exports = __webpack_public_path__ + "media/images/vp/slider.index.forum-eedbd7108b05fa846cb52e96a02e4711.jpg";